import { useNavigate, useLocation } from "react-router-dom";
import { ScanLine, Package } from "lucide-react";
import { Button } from "@/components/ui/button";

const tabs = [
  {
    id: "scan",
    label: "Skanna faktura",
    icon: ScanLine,
    path: "/purchasing/scan",
    activeColor: "bg-orange-600 hover:bg-orange-700"
  },
  {
    id: "received",
    label: "Mottagna ordrar",
    icon: Package,
    path: "/purchasing/orders/received",
    activeColor: "bg-green-600 hover:bg-green-700"
  }
];

export default function ScanTabs() {
  const navigate = useNavigate();
  const location = useLocation();

  const activeTab = location.pathname === "/purchasing/orders/received" ? "received" : "scan";

  return (
    <div className="flex justify-center" data-testid="scan-tabs">
      <div className="inline-flex rounded-lg border border-border p-1 bg-card">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          const Icon = tab.icon;
          return (
            <Button
              key={tab.id}
              variant={isActive ? "default" : "ghost"}
              className={`gap-2 ${isActive ? tab.activeColor : ""}`}
              onClick={() => !isActive && navigate(tab.path)}
              data-testid={`scan-tab-${tab.id}`}
            >
              <Icon className="h-4 w-4" />
              {tab.label}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
